// Maria, 17 October 2026: the top of the profile names only the tabs with something outstanding, with a pop-up of
// what is missing. On a tab with more than one section, the sections still to confirm are listed at the top.
// The section names are the ones the server sends in needsConfirmation (StudentProfileHelper in the backend).
export const SECTION_TABS = {
    Basic: {route: 'basic', title: 'Profile'},
    Contacts: {route: 'contact', title: 'Contacts'},
    Cultural: {route: 'background', title: 'Cultural'},
    'Medical Conditions': {route: 'medical', title: 'Medical Conditions'},
    'Medical Events': {route: 'medical', title: 'Medical Events'},
    'Medical Notes': {route: 'medical', title: 'Medical Notes'},
    'OTC Medication': {route: 'medical', title: 'Non-Prescription (OTC) Medication'},
    'Medicine at School': {route: 'medical', title: 'Medicine at School'},
    'GP Details': {route: 'medical', title: 'GP Details'},
    'Special Educational Needs': {route: 'sen', title: 'Special Educational Needs and Disabilities'},
    Dietary: {route: 'dietary', title: 'Dietary Needs'},
    'Pupil Premium and Young Carers': {route: 'welfare', title: 'Pupil Premium and Young Carers'},
    Welfare: {route: 'welfare', title: 'Welfare Information'},
    Consents: {route: 'consents', title: 'Consents'},
    'Travel Mode': {route: 'transport', title: 'Transport'}
};

// Tabs with at least one section that can be confirmed. Maria, 17 October 2026: these show 'CONFIRMED' in green when
// nothing on them is outstanding.
export const CONFIRMABLE_ROUTES = [...new Set(Object.values(SECTION_TABS).map(x => x.route))];

export const isTabConfirmed = (profile, route) => CONFIRMABLE_ROUTES.includes(route) &&
    !outstandingSectionNames(profile).some(name => SECTION_TABS[name]?.route === route);

// Tabs that contain more than one section that can be confirmed.
const TABS_WITH_SEVERAL_SECTIONS = Object.values(SECTION_TABS)
    .map(x => x.route)
    .filter((route, index, all) => all.indexOf(route) !== index);

export const outstandingSectionNames = profile => {
    const sections = profile?.needsConfirmation;
    if (!sections || sections.length === 0) return [];

    return Array.isArray(sections) ? sections : String(sections).split(',').map(x => x.trim()).filter(Boolean);
};

// [{route, label, missing: [titles]}] in the order of the tabs on screen.
export const outstandingTabs = (profile, tabs) => tabs
    .map(tab => ({
        route: tab.route,
        label: tab.label,
        missing: outstandingSectionNames(profile)
            .filter(name => (SECTION_TABS[name]?.route ?? null) === tab.route)
            .map(name => SECTION_TABS[name].title)
            .filter((title, index, all) => all.indexOf(title) === index)
    }))
    .filter(tab => tab.missing.length > 0);

// The sections still to confirm on one tab, only when that tab has more than one section.
export const unconfirmedOnTab = (profile, route) => TABS_WITH_SEVERAL_SECTIONS.includes(route)
    ? outstandingTabs(profile, [{route, label: ''}])[0]?.missing ?? []
    : [];
